type GetVariantArgs = {
    /**
     * Path to the style collection on our theme-ui style object.
     * Example: 'buttons' for buttons or 'buttons.icon' for icon buttons
     */
    stylePath: string;

    /**
     * The variant defined on the theme-ui style object.
     * Example: 'primary' for variant and 'buttons' for stylePath would result in 'buttons.primary'
     */
    variant?: string;

    /**
     * If no variant is given, the key to lookup your default values on the theme-ui style object.
     */
    defaultKey?: string;
};

/**
 * Utility for looking up variants on the theme-ui style object.
 * This utility enforces the following pattern: 'category.variant' or 'category.subCategory.variant'
 * Example: 'buttons.icon.default' or 'buttons.icon.seconday'
 */
export function getVariant({ stylePath, variant, defaultKey = 'default' }: GetVariantArgs): string {
    return `${stylePath}.${variant || defaultKey}`;
}

/**
 * User 'getVariant' instead
 */
export const getVariantOrBase = (base: string, variant?: string): string => (variant ? `${base}-${variant}` : base);
